<section class="panel config-top-panel">
  <h2>{{ 'userConfig.title' | t }}</h2>
  <div class="grid two">
    <label>
      {{ 'userConfig.baseProduct' | t }}
      <select [(ngModel)]="selectedProductId" (ngModelChange)="onProductChanged()">
        <option value="">{{ 'userConfig.selectProduct' | t }}</option>
        <option *ngFor="let product of products" [value]="product.id">{{ product.name }}</option>
      </select>
    </label>
    <label>
      {{ 'userConfig.savedConfigurations' | t }}
      <select [(ngModel)]="selectedSavedConfigurationId">
        <option value="">{{ 'common.none' | t }}</option>
        <option *ngFor="let saved of savedConfigurations" [value]="saved.id">{{ saved.name }}</option>
      </select>
    </label>
  </div>
  <div class="actions">
    <button type="button" class="secondary" (click)="applySavedConfiguration()" [disabled]="busy || !selectedSavedConfigurationId">
      {{ 'userConfig.load' | t }}
    </button>
  </div>
</section>

<div class="config-layout">
  <div class="config-main">
    <section class="panel" *ngFor="let step of steps; let index = index" [hidden]="!isStepVisible(index)">
      <h2>{{ step.orderNo }}. {{ step.componentTypeName }} ({{ selectedCount(step) }}/{{ step.quantity }})</h2>
      <div class="option-grid" *ngIf="step.options.length; else noOptions">
        <div
          class="option-card"
          *ngFor="let option of step.options"
          [class.selected]="isSelected(step, option)"
          [class.locked]="option.required"
          [class.disabled]="isOptionDisabled(step, option) && !isSelected(step, option)"
          [attr.aria-disabled]="(isOptionDisabled(step, option) && !isSelected(step, option)) ? true : null"
          (click)="toggleOption(step, option)"
        >
          <div class="option-card-head">
            <strong>{{ option.componentName }}</strong>
            <button
              type="button"
              class="secondary icon-button option-info"
              [attr.aria-label]="'userConfig.infoIcon' | t"
              [title]="option.componentDescription || ('userConfig.noDescription' | t)"
              (click)="$event.preventDefault(); $event.stopPropagation()"
            >
              i
            </button>
          </div>
          <div class="option-meta">
            <span *ngIf="option.required">{{ 'userConfig.required' | t }}</span>
            <span *ngIf="!option.required && option.defaultSelected">{{ 'userConfig.default' | t }}</span>
          </div>
          <div class="option-price">
            <span>{{ 'userConfig.price' | t }}</span>
            <span class="option-price-value"></span>
          </div>
        </div>
      </div>
      <ng-template #noOptions>
        <p>{{ 'userConfig.noOptions' | t }}</p>
      </ng-template>
    </section>

    <section class="panel" *ngIf="selectedProductId">
      <h2>{{ 'userConfig.saveTitle' | t }}</h2>
      <div class="grid two">
        <label>
          {{ 'userConfig.saveName' | t }}
          <input [(ngModel)]="saveName" />
        </label>
      </div>
      <div class="actions">
        <button type="button" (click)="saveConfiguration()" [disabled]="busy">{{ 'userConfig.save' | t }}</button>
      </div>
    </section>
  </div>

  <aside class="panel config-summary">
    <h2>{{ 'userConfig.currentConfiguration' | t }}</h2>
    <p><strong>{{ 'userConfig.baseProduct' | t }}:</strong> {{ selectedProductName() }}</p>
    <div *ngFor="let step of steps">
      <p><strong>{{ step.orderNo }}. {{ step.componentTypeName }}</strong></p>
      <ul *ngIf="selectedOptions(step).length; else noSelection">
        <li *ngFor="let selected of selectedOptions(step)">{{ selected.componentName }}</li>
      </ul>
      <ng-template #noSelection>
        <p>{{ 'common.none' | t }}</p>
      </ng-template>
    </div>
  </aside>
</div>

<section class="panel" *ngIf="error">
  <p class="error">{{ error }}</p>
</section>

<section class="panel" *ngIf="info && !error">
  <p class="info">{{ info }}</p>
</section>
